import { getStore, setStore, removeStore } from './store';

const adminToken = 'ADMIN-TOKEN';
const username = 'USER-NAME';
const ladyId = 'LADY-ID';

// 获取token
export function getToken() {
  return getStore(adminToken);
}

// 设置token
export function setToken(sid) {
  return setStore(adminToken, sid);
}

// 删除token
export function removeToken() {
  return removeStore(adminToken);
}

// 获取username
export function getUsername() {
  return getStore(username);
}

// 设置username
export function setUsername(val) {
  return setStore(username, val);
}

// 删除username
export function removeUsername() {
  return removeStore(username);
}

//获取配送员id
export function getLadyId() {
    return getStore(ladyId)
}

//设置配送员id
export function setLadyId() {
    return setStore(ladyId)
}

//删除配送员id
export function removeLadyId() {
    return removeStore(ladyId)
}